module.exports = __webpack_public_path__ + "img/trophy.5e53995e.png";